<template>
  <v-container>
    <v-btn fab icon @click="$router.go(-1)" >
      <v-icon style="font-weight: bold; font-size: 2.5rem">chevron_left</v-icon>
    </v-btn>
    <v-layout  row wrap>
      <v-progress-linear indeterminate v-if="firstLoading"></v-progress-linear>
      <v-flex lg4 xs12>
        <v-progress-linear v-if="loading && !firstLoading" indeterminate></v-progress-linear>
        <div v-if="!firstLoading" style="margin-right: 2rem">
          <v-autocomplete v-if="schemas" v-model="payload.schema_id" :items="schemas" item-text="name"
                          item-value="id" label="Wybierz schemat"
                          style="width:100%" @change="changeSchema($event)"></v-autocomplete>
         <v-layout>
           <v-flex xs11>
             <v-autocomplete
                 style="width:100%" v-if="workers.length > 0"
                 v-model="payload.worker_guid"
                 :items="workers"
                 item-text="name"
                 item-value="guid"
                 label="Pracownik"
                 :filter="filterWorkers"
             >
               <template v-slot:selection="data" >
                 {{ data.item ? data.item.name + " " +  data.item.surname : ''}}
               </template>
               <template v-slot:item="data" >
                 {{ data.item ? data.item.name + " " +  data.item.surname : ''}}
               </template>
             </v-autocomplete>
           </v-flex>
           <v-flex xs1>
             <v-dialog v-model="dialog" width="700">
               <template v-slot:activator="{on}">
                   <v-icon style="float: right;margin-top: 20px" color="green" v-on="on">person_add</v-icon>
               </template>
               <NewWorker v-on:created="newWorker($event)"></NewWorker>
             </v-dialog>
           </v-flex>
         </v-layout>

          <v-menu :close-on-content-click="true" :nudge-right="40" full-width lazy min-width="290px"
                  offset-y
                  transition="scale-transition">
            <template v-slot:activator="{ on }">
              <v-text-field v-model="payload.document_date" label="Data dokumentu" readonly clearable v-on="on"></v-text-field>
            </template>
            <v-date-picker
                v-model="payload.document_date"
                locale="pl"
                :landscape="true">
            </v-date-picker>
          </v-menu>
          <v-checkbox v-model="infinityDate" label="Dokument bez daty ważności"></v-checkbox>
          <v-menu v-if="!infinityDate" :close-on-content-click="true" :nudge-right="40" full-width
                  lazy min-width="290px"
                  offset-y transition="scale-transition">
            <template v-slot:activator="{ on }">
              <v-text-field v-model="payload.expiration_date" label="Data ważności dokumentu" readonly clearable v-on="on"></v-text-field>
            </template>
            <v-date-picker
                v-model="payload.expiration_date"
                locale="pl"
                :landscape="true">
            </v-date-picker>
          </v-menu>

          <div  v-on:click="fieldClicked($event,field)"  style="margin-top:20px" v-for="field in fields" :key="field.id">
            <component  :ref="`field_${field.order}`" :field="field" :is="getInputComponent(field.type)" :context="Context.createFormContextWithFields(fields)" :value="getValue(field.order)" @setValue="setValue($event, field.order)">
            </component>
          </div>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn  v-if="fields.length > 0" :disabled="loading || firstLoading" large round class="primary" @click="submit(states.COMPLETED)">{{ $t("base.save") }}</v-btn>
          </v-card-actions>
        </div>

      </v-flex>

      <v-flex lg8 xs12 v-if="document && document.file">
<!--        <DocumentImageManager :disable-loading="firstLoading" :document-id="$route.params.documentId" v-on:textRecognized="textRecognized($event)"/>-->
        <PDFViewer :base64="`data:application/pdf;base64,${this.document.file.data}`"></PDFViewer>

      </v-flex>

    </v-layout>

  </v-container>
</template>

<script>
import http from "@/plugins/http"
import TextInput from "@/components/form/inputs/Text"
import NumberInput from "@/components/form/inputs/Number"
import DateInput from "@/components/form/inputs/Date"
import TimeInput from "@/components/form/inputs/Time"
import RadioInput from "@/components/form/inputs/Radio"
import TableInput from "@/components/form/inputs/Table"
import MultipleInput from "@/components/form/inputs/Multiple"
import SignatureInput from "@/components/form/inputs/Signature"
import PhotoInput from "@/components/form/inputs/Photo"
import CodeInput from "@/components/form/inputs/Code"
import ArchiveInput from "@/components/form/inputs/Archive"
import RelatedInput from "@/components/form/inputs/Related"
import DependInput from "@/components/form/inputs/SelectDepend"
import CheckboxInput from "@/components/form/inputs/Checkbox"
import states from '@/enums/states'
import Context from '@/plugins/Context'
import Messenger from "@/plugins/Messenger"
import NewWorker from "@/components/document/worker/NewWorker"
import DocumentImageManager from "@/components/document/DocumentImageManager"
import DialogPicker from "@/components/common/DialogPicker"
import Document from "@/mixins/Document"
import PDFViewer from '@/components/pdf/Viewer'

export default {
  name: "Edit",
  components: {
    NewWorker,
    Messenger,
    DialogPicker,
    TextInput,
    NumberInput,
    DateInput,
    TimeInput,
    RadioInput,
    TableInput,
    MultipleInput,
    SignatureInput,
    PhotoInput,
    CodeInput,
    ArchiveInput,
    RelatedInput,
    CheckboxInput,
    DependInput,
    DocumentImageManager,
    PDFViewer
  },
  mixins: [Document],
  data() {
    return {
      dialog : false,
      archive:{},
      Context,
      formName: "",
      fields: [],
      schema : {},
      schemas : false,
      document : {},
      workers: [],
      states: states,
      payload: {
        results: [],
        worker_guid : null
      },
      loading: false,
      firstLoading : true
    }
  },
  computed: {
    values() {
      return this.relatedValues
    }
  },
  created() {
    this.firstLoading = this.loading = true
    this.formName = "Wybierz schemat"
    let schemas = http.get(`/schemas`)
    let workers = http.get(`/document/workers?active=1`)
    let doc = http.get('document/' + this.$route.params.documentId)

    Promise.all([doc, workers, schemas]).then(data => {
      this.document = data[0].data
      this.workers = data[1].data
      this.schemas = data[2].data
      this.firstLoading = this.loading = false
      this.payload.worker_guid = this.document.worker_guid
      this.payload.document_date = this.document.document_date
      this.payload.expiration_date = this.document.expiration_date

      if (this.document.expiration_date != '9999-12-31' && this.document.expiration_date != null) {
        this.infinityDate = false
      }

      if (this.document && this.document.schema.id) {
        this.payload.schema_id = parseInt(this.document.schema.id)
        this.changeSchema(this.payload.schema_id)
      }
    }).catch(() => Messenger.emitError("Problem z załadowaniem dokumentu"))

  },
  methods: {
    newWorker(data){

      this.dialog = false
      this.workers.push(data)
    },
    submit(state) {
      if(!this.validatePayloadData()){
        return
      }

      if(this.infinityDate){
        this.payload.expiration_date = '9999-12-31'
      }

      this.firstLoading = true
      this.payload.state = state
      this.payload.results = this.payload.results.filter(this.notUpdateField)

      http.post('document/'+ this.$route.params.documentId + '/schema/' + this.payload.schema_id + '/create-form', this.payload)
        .then(() => {
          this.firstLoading = false
          this.$store.commit("setSnack", {
            "message": this.$t("form.fill.success-message", {
              "form-name": this.formName
            }),
            "color": "success"
          })

        }).catch(() => {
          this.firstLoading = false
          Messenger.emitError("Nie można przypisać formularza")
        })
    }
  },
}
</script>

<style>

</style>
